
import { inject, ref, nextTick } from "vue";
import { useRouter } from "vue-router";
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    width: {
      typr: String,
      default: "90",
    },
  },
  setup(props: any) {
    const $store: any = inject("$store");
    const refClsDivs: any = ref(null);
     const router = useRouter();
    const currencyUnit = $store.getSymbol();
    nextTick(() => {
      refClsDivs.value.style.setProperty(
        "--max_width",
        props.width == "100%" ? props.width : props.width + "px"
      );
    });

    let unifiedJump = (item:any)=>{  
      console.log('item',item);
      
        router.push({ 
        path:'/search',
        query:{
            bind_keywords:'',
            bind_cid:item.gc_id
        }
     })

    }

    return {
      currencyUnit,
      unifiedJump,
      refClsDivs,
    };
  },
};
